import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  View,
  FlatList,
  StyleSheet,
  Text,
  TouchableWithoutFeedback,
} from "react-native";
import { useHistory } from "react-router-dom";
import Col from "../../layouts/Col";
import Row from "../../layouts/Row";
import FieldPulse from "../../services/fieldpulse";
import palette from "../../styles/palette";
import IconButton from "../Buttons/IconButton/index";
import Icon from "react-native-vector-icons/Feather";
import CustomersContext from "../../contexts/CustomersContext";
import ConversationContext from "../../contexts/ConversationContext";
import SplashScreen from "../../screens/SplashScreen/index.web";
import Logo from "../Logo/index";
import Avatar from "~/components/Avatar";
import SolidButton from "../Buttons/SolidButton";
import AnimatedLogo from "../Logo/AnimatedLogo/index";
import StyledInput from "~/components/StyledInput/";
import useCustomerSearch from "~/hooks/useCustomerSearch";
import useTwilio from "~/hooks/useTwilio";

export default function CustomersList({ onPress }) {
  const history = useHistory();
  const { updateFilter, loading, customers, setSearchSuggestions } =
    useContext(CustomersContext);

  const { setParticipantFromCustomer } = useContext(ConversationContext);
  const [searchTerm, setSearchTerm] = useState("");
  const { startCall, activeCall } = useTwilio();

  const { customers: suggestions, loading: loadingSuggestions } =
    useCustomerSearch({
      search: searchTerm,
      limit: 10,
    });

  useEffect(() => {
    if (!loadingSuggestions && searchTerm.length > 0) {
      setSearchSuggestions(suggestions);
      console.log("updated", suggestions);
    }
  }, [suggestions, loadingSuggestions]);

  const onCallPress = (item) => {
    startCall(item.phone, item);
  };

  const onTextPress = (item) => {
    setParticipantFromCustomer(item);
    history.push("/messages/new");
  };

  const onCustomerPress = (item) => {
    setParticipantFromCustomer(item);
    if (onPress) {
      onPress(item);
    }
  };

  return (
    <View style={[styles.customers_list__container]}>
      <CustomersListControlBar />

      <CustomerSearchBar
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />

      {/* <CustomersListSortBar /> */}
      {loading && <CustomersLoadingIndicator />}
      <FlatList
        style={{ display: loading ? "none" : "flex" }}
        refreshing={loading || (loadingSuggestions && searchTerm.length > 0)}
        onRefresh={() => updateFilter(filter)}
        data={customers}
        renderItem={renderCustomerItem(
          onCustomerPress,
          onCallPress,
          onTextPress,
          !!activeCall
        )}
        keyExtractor={(item) => `${item.id}`}
      />
    </View>
  );
}

function CustomerSearchBar({ searchTerm, setSearchTerm }) {
  const { filter, updateFilter, getCustomers } = useContext(CustomersContext);

  const onIconPress = useCallback(() => {
    setSearchTerm("");
    updateFilter(filter);
    getCustomers();
  }, [filter, updateFilter]);

  return (
    <View style={[styles.customers_list__search_input_container]}>
      <StyledInput
        value={searchTerm}
        // autoFocus
        returnKeyType="done"
        placeholder="Search by name or phone"
        onChangeText={(v) => setSearchTerm(v)}
        // onBlur={onBlur}
        // blurOnSubmit={true}
        style={[styles.customers_list__search_input]}
      />

      <View style={[styles.customers_list__search_input__clear_button]}>
        <IconButton
          height={24}
          width={24}
          iconSize={24}
          iconName="x"
          // disabled={!item.phone_e164}
          onPress={onIconPress}
          iconColor={palette.light_grey}
        />
      </View>
    </View>
  );
}

const renderCustomerItem =
  (onCustomerPress, onCallPress, onTextPress, hasActiveCall) =>
  ({ item }) => {
    return (
      <TouchableWithoutFeedback onPress={() => onCustomerPress(item)}>
        <View style={[styles.customers_list__item_container]}>
          <Row pl={16} pr={16} style={{ height: 75 }}>
            {/* <Col leftCenter maxWidth={75}>
          <CustomerItemCheckBox />
        </Col> */}

            {/*             <Col leftCenter maxWidth={75}>
              <Avatar first_name={item.first_name} last_name={item.last_name} />
            </Col> */}

            <Col
              leftCenter
              size={6}
              pl={16}
              // style={{ flex: "auto", minWidth: 325, maxWidth: 425 }}
            >
              <Text
                numberOfLines={1}
                style={[styles.customers_list__item_text]}
              >
                {item.first_name} {item.last_name}
              </Text>
              <Text
                numberOfLines={1}
                style={[styles.customers_list__item_subtext]}
              >
                {item.email}
              </Text>
            </Col>

            <Col
              center
              size={3}
              // style={{ flex: "auto", minWidth: 200, maxWidth: 250 }}
            >
              <Text
                numberOfLines={1}
                style={[styles.customers_list__item_text]}
              >
                {item.phone}
              </Text>
            </Col>

            {/*             <Col center style={{ flex: "auto", minWidth: 200, maxWidth: 250 }}>
              <Text
                numberOfLines={1}
                style={[styles.customers_list__item_text]}
              >
                {item.alternate_phone || "-"}
              </Text>
            </Col> */}

            <Col leftCenter minWidth={150}>
              <Row>
                <IconButton
                  iconName="phone"
                  disabled={hasActiveCall}
                  onPress={() => onCallPress(item)}
                  iconColor={item.phone ? palette.success : palette.light_grey}
                />
                <IconButton
                  iconName="message-circle"
                  iconColor={item.phone ? palette.primary : palette.light_grey}
                  onPress={() => onTextPress(item)}
                />
                {/* <IconButton
              iconName="mail"
              iconColor={item.email ? palette.danger : palette.light_grey}
            /> */}
              </Row>
            </Col>

            <Col leftCenter maxWidth={250} minWidth={150}>
              <Row right>
                <IconButton iconName="trash" />
              </Row>
            </Col>
          </Row>
        </View>
      </TouchableWithoutFeedback>
    );
  };

const CustomersLoadingIndicator = () => {
  return (
    <View style={[styles.customers_list__loading_indicator_container]}>
      <View dataSet={{ cls: "logo-loader" }}>
        <AnimatedLogo height={60} width={60} />
      </View>
    </View>
  );
};

const CustomerItemCheckBox = ({ checked = true }) => (
  <View>
    {checked ? (
      <IconButton iconName="square" iconColor={palette.light_grey} />
    ) : (
      <IconButton iconName="check-square" iconColor={palette.primary} />
    )}
  </View>
);

const CustomersListControlBar = () => {
  const { filter, updateFilter } = useContext(CustomersContext);

  return (
    <View style={[styles.customers_list__item_control_bar_container]}>
      <Row style={{ height: "100%" }}>
        <Col leftCenter>
          <Row left>
            <SolidButton
              label="Recent"
              labelColor={filter === "recent" ? palette.white : palette.primary}
              color={
                filter === "recent" ? palette.primary : palette.transparent
              }
              onPress={() => updateFilter("recent")}
              mr={10}
            />
            <SolidButton
              label="Assigned to me"
              labelColor={
                filter === "assigned" ? palette.white : palette.primary
              }
              color={
                filter === "assigned" ? palette.primary : palette.transparent
              }
              onPress={() => updateFilter("assigned")}
              mr={10}
            />
            <SolidButton
              label="All"
              labelColor={filter === "all" ? palette.white : palette.primary}
              color={filter === "all" ? palette.primary : palette.transparent}
              onPress={() => updateFilter("all")}
              mr={10}
            />
          </Row>
        </Col>
        <Col rightCenter>
          <CustomersPaginationControls />
        </Col>
      </Row>
    </View>
  );
};

const CustomersPaginationControls = () => {
  const { page, limit, total, nextPage, prevPage } =
    useContext(CustomersContext);

  const isFirstPage = page === 1;
  const isLastPage = page * limit > total;

  return (
    <Row right>
      <Col rightCenter pl={16} pr={16}>
        <Text
          nunberOfLines={1}
          style={[styles.customers_list__item_control_bar_pagination_text]}
        >
          {!total
            ? ""
            : `${1 + page * limit - limit}-${
                isLastPage
                  ? (page - 1) * limit + (limit + total - page * limit)
                  : page * limit
              } of ${total}`}
        </Text>
      </Col>
      <IconButton
        onPress={prevPage}
        disabled={isFirstPage}
        style={[styles.customers_list__item_control_bar_pagination_controls]}
        iconName="chevron-left"
        color={palette.primary}
        iconColor={palette.white}
      />
      <IconButton
        onPress={nextPage}
        disabled={isLastPage}
        style={[styles.customers_list__item_control_bar_pagination_controls]}
        iconName="chevron-right"
        color={palette.primary}
        iconColor={palette.white}
      />
    </Row>
  );
};

const CustomersListSortBar = () => {
  return (
    <View style={[styles.customers_list__item_sort_bar_container]}>
      <Row pl={16} pr={16} style={{ height: "100%" }}>
        {/* <Col leftCenter maxWidth={75}>
          <CustomerItemCheckBox />
        </Col> */}

        <Col leftCenter style={{ flex: "auto", minWidth: 325, maxWidth: 425 }}>
          <Row>
            <Text
              numberOfLines={1}
              style={[styles.customers_list__item_label_text]}
            >
              Customer
            </Text>
            <Icon
              style={[styles.customers_list__item_label_chevron]}
              size={16}
              name="chevron-down"
            />
          </Row>
        </Col>

        <Col center style={{ flex: "auto", minWidth: 200, maxWidth: 250 }}>
          <Text
            numberOfLines={1}
            style={[styles.customers_list__item_label_text]}
          >
            Phone Number
          </Text>
        </Col>

        <Col center style={{ flex: "auto", minWidth: 200, maxWidth: 250 }}>
          <Text
            numberOfLines={1}
            style={[styles.customers_list__item_label_text]}
          >
            Secondary Phone Number
          </Text>
        </Col>

        <Col leftCenter maxWidth={250} minWidth={150}></Col>
        <Col rightCenter></Col>
      </Row>
    </View>
  );
};

const styles = StyleSheet.create({
  customers_list__container: {
    flex: 1,
  },
  customers_list__loading_indicator_container: {
    flex: 1,
    backgroundColor: "#fbfbfb",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
  customers_list__item_control_bar_container: {
    height: 65,
  },
  customers_list__item_text: {
    fontFamily: "acumin-pro, san-serif",
    fontSize: 18,
    fontWeight: "500",
  },
  customers_list__item_label_text: {
    fontFamily: "acumin-pro, san-serif",
    fontSize: 18,
    color: palette.grey,
  },
  customers_list__item_subtext: {
    fontFamily: "acumin-pro, san-serif",
    fontSize: 16,
    color: palette.grey,
  },
  customers_list__item_label_chevron: {
    padding: 5,
  },
  customers_list__item_sort_bar_container: {
    backgroundColor: palette.white,
    borderTopRightRadius: 4,
    borderTopLeftRadius: 4,
    borderTopWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: palette.light_grey,
    height: 75,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.12,
    shadowRadius: 2.62,
    elevation: 4,
    zIndex: 10,
  },
  customers_list__item_control_bar_pagination_controls: {
    borderRadius: 4,
  },
  customers_list__item_control_bar_pagination_text: {
    fontSize: 18,
  },
  customers_list__item_container: {
    backgroundColor: palette.white,
    borderTopColor: palette.light_grey,
    borderTopWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: palette.light_grey,
  },
  customers_list__search_input_container: {
    width: "100%",
    marginBottom: 8,
  },
  customers_list__search_input: {
    borderWidth: 1,
    borderRadius: 32,
    backgroundColor: "white",
  },
  customers_list__search_input__clear_button: {
    display: "flex",
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
    position: "absolute",
    height: "100%",
    right: 8,
    zIndex: 10,
    elevation: 10,
  },
});
